import { render, staticRenderFns } from "./AgentTransferListItem.vue?vue&type=template&id=fe4bdb6a"
import script from "./AgentTransferListItem.vue?vue&type=script&lang=js"
export * from "./AgentTransferListItem.vue?vue&type=script&lang=js"
import style0 from "./AgentTransferListItem.vue?vue&type=style&index=0&id=fe4bdb6a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QItemSection,QIcon,QItemLabel,QTooltip,QCard,QItem,QSpinner,QSeparator,QList});
